import { ReferenceField, ReferenceFieldProps, TextField, TextFieldProps, FunctionField } from 'react-admin';
import User from '../GeneratedModels/User';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface UserTextFieldProps extends Omit<TextFieldProps, "source"> {
  source: 'id' | 'username' | 'password' | 'api_key' | 'email' | 'telephone' | 'mobile' | 'address_1' | 'address_2' | 'firebase_uid' | 'firebase_email' | 'firebase_phone' | 'role' | 'release' | 'expiry' | 'image_file' | 'image_filename' | 'image_filesize' | 'created' | 'createdBy' | 'updated' | 'updatedBy',
}

interface UserReferenceFieldProps extends Omit<ReferenceFieldProps, 'children' | 'source' | 'reference'> {
  source?: string,
  reference?: string,
  textFieldProps?: UserTextFieldProps
  render?: (record: User) => string,
}

const UserReferenceField = ({ source, reference, render, textFieldProps, ...rest }: UserReferenceFieldProps) => {
  return (
    <ReferenceField {...rest} source={source ?? 'user_id'} reference={reference ?? 'user'}>
      {render
        ? <FunctionField render={render} />
        : <TextField {...textFieldProps} />
      }
    </ReferenceField>
  )
}

UserReferenceField.defaultProps = {
  addLabel: true,
  // label: "User",
  source: "user_id",
  reference: "user",
  textFieldProps: {
    source: 'username',
  },
};

export default UserReferenceField;
